import { createInfiniteQuery } from 'react-query-kit';

import { fetchData } from 'services/http/http';
import { buildFilterUrl } from 'support/helpers/urls/urls';
import portalSchema from 'support/types/schema-portal';
import { Filter } from 'components/ListTable/types';

export const CONNECTIONS_QUERY_KEY = '/connections';
export type ConnectionsResponseDTO =
  portalSchema.paths['/v1/connections']['get']['responses']['200']['content']['application/json'];

export const useInfiniteConnections = createInfiniteQuery<ConnectionsResponseDTO, { query?: Filter }, Error>({
  primaryKey: CONNECTIONS_QUERY_KEY,
  queryFn: async ({ queryKey: [, variables], pageParam }) => {
    const urlParams = buildFilterUrl(
      { filterValues: [], ...variables.query, cursor: pageParam },
      { forApiRequest: true },
    );

    const { data } = await fetchData<ConnectionsResponseDTO>('/v1/connections' + urlParams);

    return data;
  },
  getNextPageParam: (lastPage) => {
    return lastPage.meta.next_cursor;
  },
  getPreviousPageParam: (_, allPages) => allPages.at(-1)?.meta.prev_cursor,
});
